import React, { useState } from 'react';
import moment from 'moment';
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography
} from '@material-ui/core';

import SalesRangePicker from 'components/Accounts/SalesRangePicker';
import SalesTable from 'components/Accounts/SalesTable';
import InvoicesDisplay from 'components/Accounts/InvoicesDisplay';
import MonthlyVATTable from 'components/Accounts/MonthlyVATTable';
import MonthlyCCTable from 'components/Accounts/MonthlyCCTable';
import DailyAccounts from 'components/Accounts/DailyAccounts';

const months = [
  { month: '--Select Month--', num: -1 },
  { month: 'January', num: 0 },
  { month: 'February', num: 1 },
  { month: 'March', num: 2 },
  { month: 'April', num: 3 },
  { month: 'May', num: 4 },
  { month: 'June', num: 5 },
  { month: 'July', num: 6 },
  { month: 'August', num: 7 },
  { month: 'September', num: 8 },
  { month: 'October', num: 9 },
  { month: 'November', num: 10 },
  { month: 'December', num: 11 }
];

const AccountsDisplay = (props) => {
  
  const [dates, setDates] = useState({});
  const [VATMonth, setVATMonth] = useState(-1);
  const [CCMonth, setCCMonth] = useState(-1);

  const [openSalesTable, setOpenSalesTable] = useState(false);
  const [openDailyAccounts, setOpenDailyAccounts] = useState(false);
  const [openMonthlyVATTable, setOpenMonthlyVATTable] = useState(false);
  const [openMonthlyCCTable, setOpenMonthlyCCTable] = useState(false);

  const showSalesTable = (dates) => {
    setOpenSalesTable(true);
    setDates(dates);
  };
  
  const hideSalesTable = () => {
    setOpenSalesTable(false);
    setDates({});
  };
  
  const showMonthlyVATTable = (event) => {
    setOpenMonthlyVATTable(true);
    setVATMonth(event.target.value);
  };

  const hideMonthlyVATTable = () => {
    setOpenMonthlyVATTable(false);
    setVATMonth(-1);
  };
  
  const showMonthlyCCTable = (event) => {
    setOpenMonthlyCCTable(true);
    setCCMonth(event.target.value);
  };

  const hideMonthlyCCTable = () => {
    setOpenMonthlyCCTable(false);
    setCCMonth(-1);
  };

  const hideDailyAccounts = () => {
    setOpenDailyAccounts(false);
  };

  return (
    <Box>
      <Box>
        { openSalesTable ?
        //isBetween(start, end, unit, "()"- both exclusive "[]"- both inclusive)
        <SalesTable
          salesOrders={props.salesOrders.filter(salesOrder => moment(salesOrder.createdAt).isBetween(dates.startDate, dates.endDate, 'day', '[]'))}
          expenses={props.expenses.filter(expense => moment(expense.createdAt).isBetween(dates.startDate, dates.endDate, 'day', '[]'))}
          returnOrders={props.returnOrders.filter(returnOrder => moment(returnOrder.createdAt).isBetween(dates.startDate, dates.endDate, 'day', '[]'))}
          purchaseOrders={props.purchaseOrders} 
          dates={dates}
          hideSalesTable={hideSalesTable}
        /> :
        <React.Fragment>
          <Button
            color="primary"
            variant="contained"
            onClick={props.hideAccountsDisplay}
          >
            Return
          </Button>
          <Typography
            color="textPrimary"
            variant="h4"
          >
            Profit and Loss
          </Typography>
          <SalesRangePicker
            showSalesTable={showSalesTable}
          />
          <InvoicesDisplay
            salesOrders={props.salesOrders}
            purchaseOrders={props.purchaseOrders}
            returnOrders={props.returnOrders}
            products={props.products}
            customers={props.customers}
            vendors={props.vendors}
            user={props.user}
          />
          <Typography
            color="textPrimary"
            variant="h4"
          >
            Other Reports
          </Typography>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={3}
              xs={12}
            >
              <p>Display Monthly VAT</p>
              <TextField
                select
                helperText="Please select the Month"
                label="Select Month"
                onChange={showMonthlyVATTable}
                SelectProps={{ native: true }}
                style={{ width: 300 }}
                value={VATMonth}
                variant="outlined"
              >
                {months.map((obj) => (
                  <option
                    key={obj.num}
                    value={obj.num}
                  >
                    {obj.month}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
            >
              <p>Show Daily Account</p>
              <Button
                color="primary"
                variant="contained"
                onClick={() => setOpenDailyAccounts(true)}
              >
                Daily Account
              </Button>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
            >
              <p>Display Monthly Cash / Card</p>
              <TextField
                select
                helperText="Please select the Month"
                label="Select Month"
                onChange={showMonthlyCCTable}
                SelectProps={{ native: true }}
                style={{ width: 300 }}
                value={CCMonth}
                variant="outlined"
              >
                {months.map((obj) => (
                  <option
                    key={obj.num}
                    value={obj.num}
                  >
                    {obj.month}
                  </option>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </React.Fragment> }
      </Box>
      { openMonthlyVATTable ?
      <MonthlyVATTable
        open={openMonthlyVATTable}
        month={VATMonth}
        salesOrders={props.salesOrders}
        expenses={props.expenses}
        purchaseOrders={props.purchaseOrders}
        returnOrders={props.returnOrders}
        closeModal={hideMonthlyVATTable}
      /> : null }
      { openDailyAccounts ?
      <DailyAccounts
        open={openDailyAccounts}
        salesOrders={props.salesOrders}
        expenses={props.expenses}
        purchaseOrders={props.purchaseOrders}
        returnOrders={props.returnOrders}
        closeModal={hideDailyAccounts}
      /> : null }
      { openMonthlyCCTable ?
      <MonthlyCCTable
        open={openMonthlyCCTable}
        month={CCMonth}
        salesOrders={props.salesOrders}
        closeModal={hideMonthlyCCTable}
      /> : null }
    </Box>
  )
};

export default AccountsDisplay;